//@ts-check
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { IPdpData, Attribute } from '../types/PDP';
import { convertCamelCaseToTitle } from '../utils';
import BraGuide from './ProductBraGuide';
import WarmthGuide from './ProductWarmthGuide';
import TestedAndApproved from './TestedAndApproved';
import { marked } from 'marked';

const ProductInfo = ({
  pdpData,
  apparelAttribs,
  beautyAttribs,
  descriptionHtml,
}: {
  pdpData: IPdpData;
  apparelAttribs: Attribute[];
  beautyAttribs: Attribute[];
  descriptionHtml: string;
}) => {
  return (
    <div className="description row description__row">
      <div className="description__line" />
      <div className="col-6">
        <h4 className="h4 black semibold uppercase">Description</h4>
        <div className="small-p" dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
        {beautyAttribs[0] ? <TestedAndApproved attribute={beautyAttribs[0]} /> : null}
        <BraGuide tags={pdpData.pdpProductShell.tags} productType={pdpData.products[0].productType} />
        <WarmthGuide tags={pdpData.pdpProductShell.tags} />
      </div>
      <div className="col-6 attributes__row">
        {apparelAttribs.map(({ label, value: rawValue }) => {
          const value = rawValue.startsWith('(md)')
            ? rawValue.slice(4)
            : rawValue
                .split(/\r?\n/)
                .map((text) => `- ${text}`)
                .join('\n');
          return (
            <div className={`${label}`} key={label}>
              <h4 className="h4 black semibold uppercase">{convertCamelCaseToTitle(label)}</h4>
              <span
                className="attributes-markdown-block"
                dangerouslySetInnerHTML={{
                  __html: marked(value),
                }}
              />
            </div>
          );
        })}
      </div>
      <div className="description__line" />
    </div>
  );
};

export default React.memo(ProductInfo);
